var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.93335 4.0835C2.93335 3.25854 2.93335 2.84606 3.18963 2.58978C3.44591 2.3335 3.85839 2.3335 4.68335 2.3335C5.50831 2.3335 5.92079 2.3335 6.17707 2.58978C6.43335 2.84606 6.43335 3.25854 6.43335 4.0835V9.91683C6.43335 10.7418 6.43335 11.1543 6.17707 11.4106C5.92079 11.6668 5.50831 11.6668 4.68335 11.6668C3.85839 11.6668 3.44591 11.6668 3.18963 11.4106C2.93335 11.1543 2.93335 10.7418 2.93335 9.91683V4.0835Z",
    stroke: "#B54708",
    strokeWidth: 0.875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76685 4.0835C8.76685 3.25854 8.76685 2.84606 9.0231 2.58978C9.27942 2.3335 9.6919 2.3335 10.5168 2.3335C11.3418 2.3335 11.7543 2.3335 12.0106 2.58978C12.2668 2.84606 12.2668 3.25854 12.2668 4.0835V9.91683C12.2668 10.7418 12.2668 11.1543 12.0106 11.4106C11.7543 11.6668 11.3418 11.6668 10.5168 11.6668C9.6919 11.6668 9.27942 11.6668 9.0231 11.4106C8.76685 11.1543 8.76685 10.7418 8.76685 9.91683V4.0835Z",
    stroke: "#B54708",
    strokeWidth: 0.875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.9bacfe41.svg";
export { ForwardRef as ReactComponent };